<template>
    <div>
         <div class="uk-margin" uk-margin>
            <div uk-form-custom="target: true">
                <input type="file" v-on:change="select" multiple>
                <input class="uk-input uk-form-width-medium" type="text" placeholder="Kies Afbeeldingen" disabled>
            </div>
            
        </div>
        <div v-for="(f, i) in files" v-if="loaded[0+i] != 100">
            <p class="uk-text-muted">{{f.name}}</p>
            <progress  id="js-progressbar" class="uk-progress" :value="loaded[0+i]" max="100"></progress>
        </div>
        <div v-if="showForm" class="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin" v-for="(img, i) in URLS" uk-grid>
            <div class="uk-card-media-left uk-cover-container">
                <img :src="img.url" alt="" uk-cover>
                <canvas width="600" height="400"></canvas>
            </div>
            <div>
                <div class="uk-card-body">
                    <h3 class="uk-card-title">Afbeelding Info</h3>
                    <form>
                        <div class="uk-margin">
                            <label for="title">Titel</label><br>
                            <input v-model="img.title" id="title" name="title" class="uk-input" type="text" palceholder="title"/>
                        </div>
                    <div class="uk-margin">
                            <label for="title">Alt</label><br>
                            <input v-model="img.alt" id="title" name="alt" class="uk-input" type="text" palceholder="alt"/>
                        </div>
                        <div class="uk-margin">
                            <label for="title">Caption</label><br>
                            <textarea v-model="img.caption" id="title" name="caption" class="uk-input" type="text" palceholder="caption"/>
                        </div>
                        <div class="uk-margin">
                            <label for="title">Beschrijving</label><br>
                            <textarea v-model="img.description" id="title" name="description" class="uk-input" type="text" palceholder="Beschrijving"/>
                        </div>
                        <div class="uk-margin">
                            <button class="uk-button uk-button-primary uk-align-left" type="submit" @click.prevent="saveInfo(i)">Save</button>
                            <p v-if="status[i]">{{status[i]}}</p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import firebase from 'firebase'
import {db, storageRef} from '@/CUSTOM/helpers/firebase'
export default {
    name: 'imageUploader',
    props: {
        showForm: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            files: [],
            loaded: [],
            URLS: {},
            status: {},
            uploaded: 0,
        }
    },
    methods: {
        upload (file, index) {
            var id = Math.floor(Math.random() * 90 + 10).toString()
            var extention = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2)
            var name = file.name.slice(0, -(extention.length + 1)) + "_" + id + '.' + extention;
            var uploadTask = storageRef.child('uploads/'+name).put(file)
            uploadTask.on('state_changed', snap => {
                Vue.set(this.loaded, index , snap.bytesTransferred / snap.totalBytes * 100)
            }, (error) => {
                throw error
            }, (res) => {
                db.collection('media').add({url: uploadTask.snapshot.downloadURL, alt: "", title: "", caption: "", description: "", uploaded: Math.floor(Date.now() / 1000)}).then(success => {
                    this.uploaded++;
                    this.files.splice(index, 1)
                    this.URLS[success.id] = {url: uploadTask.snapshot.downloadURL, alt: "", title: "", caption: "", description: ""}
                    var metadata = {
                        customMetadata: {
                            'mediaId': success.id
                        }
                    }
                    storageRef.child('uploads/'+name).updateMetadata(metadata).then(res => {
                        this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Afbeelding upgeload', status: 'success'})
                        console.log(success.id)
                    }).catch(error => {
                        console.log('error updating metadata')
                        throw error;
                    })
                    if(this.uploaded == this.files.length) {
                        this.$emit('uploaded', this.URLS);
                    }
                }).catch(error => {
                    console.log(error)
                    storageRef.child('media/'+file.name).delete().then(succ => {
                        console.log('removed image due to an error')
                    }).catch (error => {
                        console.log('unable to remove image after error.')
                        console.log('error')
                    })
                })
            });
        },
        select (event) {
            Array.prototype.forEach.call(event.target.files, (file) => { 
                this.files.push(file)
                this.upload(file, this.files.length - 1)
            });
        },
        saveInfo (i) {
            Vue.set(this.status, i, 'Saving...')
            db.collection('media').doc(i).update(this.URLS[i]).then(success => {
                console.log('info updated')
                Vue.set(this.status, i, 'Saved!')
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// ImageUploader.vue?3800a017